export const PAGE_ROUTES = {
    NewDeals: '/event/new-deals',
    MyLounge: '/event/:categoryTabId?',
    ErrorPage: '/error-page',
};
